export default __webpack_public_path__ + "static/media/RFW.87ad5680.jpg";